if (!customElements.get('naire-service')) {
  customElements.define('naire-service', class NaireService extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-naire-hero-slide]')];
      this.index = 0;
      if (this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.timer = setInterval(() => this.showNextSlide(), 2300);
      }

      const reveals = this.querySelectorAll('[data-naire-reveal]');
      if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
        reveals.forEach((element) => element.classList.add('is-visible'));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const delay = Number(entry.target.dataset.naireReveal || 0) * 75;
          entry.target.style.transitionDelay = `${delay}ms`;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -50px 0px', threshold: 0 });
      reveals.forEach((element) => this.observer.observe(element));
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
    }

    showNextSlide() {
      this.slides[this.index]?.classList.remove('is-active');
      this.index = (this.index + 1) % this.slides.length;
      this.slides[this.index]?.classList.add('is-active');
    }
  });
}
